export default __webpack_public_path__ + "static/toggler-georgina-0eb49dad6b8cdbd8014c1120907ce787.jpg";